// src/components/BoardPack/common/SlideNavigationContext.js
import { createContext } from "react";

// Lets any nested slide (e.g. Toc_Page) jump to another slide by index
// without SlideViewer having to know about that slide's internals.
export const SlideNavigationContext = createContext(() => {});
